import * as FPT from '../utility/fpt';
import { getChildren } from './domUtils';

function trackReportLink() {
  FPT.trackLinkClick('reportInappropriateContent');
}

export function addTrackReportLink() {
  const reportLink = getChildren('.help_security')[2];
  if (reportLink) {
    reportLink.addEventListener('click', trackReportLink);
  }
}

export function removeTrackReportLink() {
  const reportLink = getChildren('.help_security')[2];
  if (reportLink) {
    reportLink.removeEventListener('click', trackReportLink);
  }
}
